export default "__VITE_ASSET__720c9cda__"